(function VideoLoop() {
  let videoloopsWithLazyPlay = document.querySelectorAll('.tc_video__videoloop--lazyplay');
  
  if (videoloopsWithLazyPlay) {
    if ('IntersectionObserver' in window) {
      // IntersectionObserver Supported    
      let options = {
        rootMargin: '0px 0px 500px 0px',
      };
    
      let observer = new IntersectionObserver(observerEntries, options);
      videoloopsWithLazyPlay.forEach(video => observer.observe(video));
    
      function observerEntries(entries) {
        entries.forEach(entry => {
          entry.isIntersecting ? entry.target.play() : entry.target.pause();
        });
      }
    
    } else {
      // IntersectionObserver NOT Supported
      videoloopsWithLazyPlay.forEach(video => video.play());
    }
  }
})();
